import React, { useState } from "react";
import BizinBackend from "../../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import InputEditorCustom from "../../Inputs/InputEditorCustom";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";

const LIMIT_DIMENSION_IMG = 1000;

const InputSendMessage = ({data, onSuccess = () => {}}) => {
    const csrfToken = useGetCsrfToken();
    const profile = useSelector(state => state.login.user);
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [filesUploaded, setFilesUploaded] = useState([]);
    const [imagesUploaded, setImagesUploaded] = useState([]);
    const idArquivo = data?.ID_Arquivo

    function extractTypeFile(text) {
      return text.split('/')[0].split(':')[1];
    }

    function extrairTipoBase64(text) {
      return text.split(';')[0].split('/')[1];
    }

    const getIconByFileType = (type) => {
      switch (String(type).toLocaleLowerCase()) {
        case 'pdf':
          return 'far fa-file-pdf';
        case 'doc':
        case 'docx':
          return 'far fa-file-word';
        case 'xlsx':
        case 'xls':
          return 'far fa-file-excel';
        default:
          return 'far fa-file';
      }
    }

    const getTypeFile = (type) => {
      switch (String(type).toLocaleLowerCase()) {
        case 'pdf':
          return 'PDF';
        case 'png':
        case 'jpeg':
        case 'jpg':
          return 'IMAGE';
        default:
          return 'DOC';
      }
    }

    const handleSendMessage = async () => {
      const getSrc = /<img[^>]*src="([^"]+)"[^>]*\/?>/gi;
      const images = []
      const filePromises = []
      const extensions = []
      let filesUrls = []

      const messageWhithoutImages = message?.replace(getSrc, (_, src) => {
        const image = imagesUploaded.find(image => image.src === src)
        if(image) {
          images.push(image);
          return '';
        }else{
          if(src.startsWith('data:')) {
            const img = new Image();
            img.src = src;
            let getWidthAndHeight = img.onload = () => {
              let width = img.width;
              let height = img.height;

              if (width > LIMIT_DIMENSION_IMG || height > LIMIT_DIMENSION_IMG) {
                const aspectRatio = width / height;
                if (width > height) {
                  width = LIMIT_DIMENSION_IMG;
                  height = Math.round(width / aspectRatio);
                } else {
                  height = LIMIT_DIMENSION_IMG;
                  width = Math.round(height * aspectRatio);
                }
              }
               return {src, width, height};
            }; 
            let {src: base64, width, height} = getWidthAndHeight();
            if(base64) {
              images.push({src: base64, width, height});
              return '';
            }
          }
          return '';
        }
      });

      if(images.length > 0) {
        images.forEach(({src, width, height}) => {
          const fileName = `chat_${profile?.resultset_2[0]?.ID_Usuario}_${new Date().toISOString().replace(/[^a-zA-Z0-9]/g, "")}`
          extensions.push(extractTypeFile(src))
          const promise = new Promise(resolve => {
            BizinBackend.fileUpload({
              fileName: fileName,
              extension: extrairTipoBase64(src),
              fileBase64: src,
              crop: { width, height},
              _csrf: csrfToken,
              access_token_msman: profile?.access_token
            }).then((response) => {
              resolve({Caminho_Arquivo: response?.publicUrl, Tipo_Anexo: extrairTipoBase64(src), Nome_Arquivo: fileName})
            })
          });
          filePromises.push(promise);
        });
      }

      if(filesUploaded.length > 0) {
        filesUploaded.forEach((file) => {
          const fileName
           = `chat_${profile?.resultset_2[0]?.ID_Usuario}_${new Date().toISOString().replace(/[^a-zA-Z0-9]/g, "")}`
          extensions.push(file?.extension)
          const promise = new Promise(resolve => {
            BizinBackend.fileUpload({
              fileName: fileName,
              extension: file?.extension,
              fileBase64: file?.value,
              _csrf: csrfToken,
              access_token_msman: profile?.access_token
            }).then((response) => {
              resolve({Caminho_Arquivo: response?.publicUrl, Tipo_Anexo: file?.extension, Nome_Arquivo: fileName})
            })
          });
          filePromises.push(promise);
        });
      }

      if(filePromises.length > 0) {
        filesUrls = await Promise.all(filePromises);
      }

      if(idArquivo && (messageWhithoutImages || filesUrls.length > 0)) {
          setIsLoading(true)
          BizinBackend.executeProcedure(
            {
              1: idArquivo,
              2: null,
              3: profile?.resultset_2[0]?.ID_Usuario,
              4: null,
              5: messageWhithoutImages || null,
              6: "TEXTO",
              7: null
            },
            "FRONT_Chat_Inserir_Mensagem",
            csrfToken,
            profile?.access_token
          ).then((response) => {
              try {
                const messageId = response[0].ID_Mensagem;
                let promises = []
                
                if(filesUrls.length > 0 && messageId) {
                  filesUrls.forEach(({Caminho_Arquivo: url}, idx) => {
                    promises.push(new Promise(resolve => {
                      BizinBackend.executeProcedure(
                        {
                          1: messageId,
                          2: url.split('/').reverse()[0].split('.')[0],
                          3: url,
                          4: null,
                          5: getTypeFile(String(extensions[idx])?.toUpperCase()),
                        },
                        "FRONT_Chat_Adicionar_Anexo",
                        csrfToken,
                        profile?.access_token
                      ).then((response) => {
                        resolve(response)
                      })
                    }))
                  });
                }
                
                Promise.all(promises).then((responses) => {
                  console.log("uploaded images: ", responses);
                })
                
                onSuccess(messageWhithoutImages.trim(), filesUrls)
                setFilesUploaded([])
                setMessage('')
              } catch (error) {
                console.warn("ID na mensagem não encontrado: ", error)
              }
          }).catch((error) => {
              console.log("erro ao enviar mensagem: ", error);
          }).finally(() => {
              setIsLoading(false)
              setMessage('')
          });
      }
    };
  return (
    <>
      <div id="container-input-send-message">          
        <div className="w-100 d-flex flex-row-reverse align-items-center">
            <InputEditorCustom onTextChange={(text) => setMessage(text)} textValue={message} onTriggerSendMessage={handleSendMessage} filesUploaded={filesUploaded} onImagesUpload={(imgs) => setImagesUploaded(state => ([...state, ...imgs]))} onFilesUpload={(files) => setFilesUploaded(files)} />
          </div>
        <div className="btn-send-message ">
          <button onClick={handleSendMessage} disabled={isLoading} className="btn btn-primary bg-transparent">          
            {isLoading ? <Spinner size={"sm"} color="primary" /> : <i className="fas fa-paper-plane text-color-azul2 font-size-14"></i> }
          </button>
        </div>
      </div>
      <div className="pt-2 limit-characters d-flex align-items-center justify-content-between gap-2 mb-2">
        <p style={{flex: 'none'}} className="p-0 m-0 text-color-cinza4 font-w-400 font-size-12">Limite de caracteres: {message?.replace(/<\/?[^>]+>/g, '')?.trim()?.length || 0}/250</p>
        <div className="d-flex flex-wrap justify-content-end gap-2">
          {filesUploaded?.map((file, index) => (
            <span key={index} class="badge badge-pill bg-primary text-white p-2">
              <div className="d-flex align-items-center gap-2">
                <i class={getIconByFileType(file?.extension)}></i>
                {file?.label} 
                <i onClick={() => {
                  setFilesUploaded((prev) => prev.filter((item, idx) => idx !== index))
                }} class="fas fa-times cursor-pointer"></i>
              </div>
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

export default InputSendMessage